import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import type { PersistQueryClientOptions } from '@tanstack/react-query-persist-client';
import { del, get, set } from 'idb-keyval';

// Bump when persisted query shapes change incompatibly.
const CACHE_BUSTER = 'fdtr-v1';

const persister = createAsyncStoragePersister({
  storage: {
    getItem: (key: string) => get<string>(key).then((v) => v ?? null),
    setItem: (key: string, value: string) => set(key, value),
    removeItem: (key: string) => del(key),
  },
  key: 'wb-query-cache',
  throttleTime: 2_000,
});

/** Instant-paint restore of the FDTR feeds. Freshness is deliberately NOT
 *  persisted — it must fetch live so the staleness detector compares current
 *  sidecar stamps against the restored payloads' own stamps (staleTime is
 *  Infinity; a restored freshness query would never refetch and nothing would
 *  ever flag stale). A restored cold start thus behaves like a kept-open tab. */
export const persistOptions: Omit<PersistQueryClientOptions, 'queryClient'> = {
  persister,
  maxAge: 24 * 60 * 60 * 1000,
  buster: CACHE_BUSTER,
  dehydrateOptions: {
    shouldDehydrateQuery: (q) =>
      q.state.status === 'success' &&
      q.queryKey[0] === 'fdtr' &&
      q.queryKey[1] !== 'freshness',
  },
};
